export default __webpack_public_path__ + "static/fin-trade-sec-ea14a2249dcd62d412de3604e645181d.png";